module.exports = __webpack_public_path__ + "assets/images/3a7d8343ca794fa4688f6758b58aa957.png";